import {Table} from 'antd';
import {Link} from "react-router";
import {TaskStatusTag} from "../tasks/TaskStatusTag";

export const SimpleTaskTable = ({tasks, enableLinks=false, props}) => {
    const columns = [
        {
            title: "Task",
            dataIndex: 'title',
            key: 'title',
            render: (val, record, index) => {
                if (enableLinks) {
                    return <Link to={`/task/${record.id}`}>{val}</Link>
                } else {
                    return val;
                }
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (val, record, index) => {
                return <TaskStatusTag status={val} />
            }
        }
    ]

    return <Table dataSource={tasks} columns={columns} pagination={false} />
}